var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time"},[_c('Icon',{staticClass:"gray",attrs:{"name":"clock-outline","width":_vm.iconWidth}}),_c('span',[_vm._v(_vm._s(_vm.formatTime(_vm.time)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }